import React, { useEffect, useState } from "react";
import { Image, Nav } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";
import Logout from "../../Logout";
import { useLocation } from "react-router";
import { getSafeHref, isTrainingUser } from "../../utils/utils";
import { useAuth } from "../../components/AuthContext/AuthContext";
import {createtrainingphlebotomisturl, resettrainingphlebotomisturl} from "../../utils/constants";
import useApis from "../../services/useAPI";
import { XCircleFill, CheckCircleFill} from "react-bootstrap-icons";
import useTraining from "../../services/useTraining";

const Sidebar = ({ links, logo, isActivation }) => {
  const location = useLocation();
  const [menuLinks, setMenuLinks] = useState(links);
  const auth = useAuth();

  // Toggles the training flag between Start and Reset
const {
    toggleTrainingStart,
    toggleTrainingStop,
  } = useTraining();

const {
    callApi,
    resultPost,
    serverError,
  } = useApis();

  useEffect(()=>{
    if(resultPost){
      auth?.showToast(
              "Success",
              resultPost.message,
              undefined,
              {icon: <CheckCircleFill />,
              className: auth?.featureFlag && "vh-toaster",}
            )
          }
   if (serverError) {
         auth?.showToast(
           "Error",
           serverError,
           "../assets/mhc.png",
           {icon: <XCircleFill />},
         );
       }

  },[resultPost,serverError]);

  const currentPath = location.pathname;
  let selectedService = localStorage.getItem("selectedService");
  useEffect(() => {
    let updatedLinks = links;

    if (selectedService === "clinical") {
      updatedLinks = links.filter(
        (link) => link.text !== "Healthcare services",
      );
    } else if (selectedService === "healthCare") {
      updatedLinks = links.filter((link) => link.text !== "Clinical studies");
    }

    setMenuLinks(updatedLinks);
  }, [links, selectedService]);

  /**
   * Determines if the current path matches specific patterns for the "/patient-record" route.
   */
  const isActivePath = () => {
    // Define the patterns that should be matched for the "/patient-record" route
    const patterns = [
      /\/patient-record(\/|$)/, // Matches /patient-record or /patient-record/anything
      /\/test-confirmation\/\d+/,
      /\/enter-barcode\/\d+/,
      /\/appointment-confirmation\/\d+/,
      /\/confirmation-steps\/\d+/,
      /\/clinical-confirmation-steps\/\d+/,
    ];

    // Check if the current path matches any of the patterns
    return patterns.some((pattern) => pattern.test(currentPath));
  };

  /**
   * Determines if a given item should be marked as active based on the current path.
   */
  const isActive = (itemHref) => {
    return (
      currentPath === itemHref ||
      (itemHref === "/patient-record" && isActivePath())
    );
  };

  return (
    <div className="sidebar px-0">
      <Navbar className="bg-body-tertiary" expand="lg">
        <Container className="d-inline p-0">
          <Navbar.Brand>
            <a href="/patient-record">
              <Image
                alt="My Health Checked"
                className="d-block m-auto"
                src={logo}
              />
            </a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
            {!isActivation && isTrainingUser() && (
              <Container className="text-center mt-3">
                <button className="btn btn-primary mb-3" onClick={toggleTrainingStart}>
                   Start Training
                </button>
                <button className="btn btn-primary" onClick={toggleTrainingStop}>
                   Reset Training
                </button>
              </Container>
            )}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="flex-column">
              {!isActivation &&
                menuLinks?.map((item) => (
                  <Nav.Item key={item.href}>
                    <Nav.Link
                      active={isActive(item.href)}
                      href={getSafeHref(item.href)}
                    >
                      <div className="nav-icon">
                        <Image
                          alt={item.alt}
                          className="icon"
                          src={item.icon}
                        />
                      </div>
                      <div className="item-name ageo-medium">{item.text}</div>
                    </Nav.Link>
                  </Nav.Item>
                ))}
            </Nav>
          </Navbar.Collapse>
          {!isActivation && <Logout />}
        </Container>
      </Navbar>
    </div>
  );
};

Sidebar.propTypes = {
  logo: PropTypes.string.isRequired,
  links: PropTypes.array,
  isActivation: PropTypes.bool,
};

export default Sidebar;
